export function Document(data, group) {
    this.id = data.id;
    this.name = data.name;
    this.status = data.status;

    this.date = data.date;
    this.hasExpireDate = data.has_expire_date;

    this.sort = data.sort;

    this.absentColor = data.absent_color || group.absentColor;
    this.expiredColor = data.expired_color || group.expiredColor;
    this.expiringColor = data.expiring_color || group.expiringColor;
}

export function DocsGroup(data) {
    this.id = data.id;
    this.name = data.name;

    this.sort = data.sort;

    this.absentColor = data.absent_color || "#FF0000";
    this.expiredColor = data.expired_color || "#FF238D";
    this.expiringColor = data.expiring_color || "#FFB800";

    const documents = data && data.docs.length > 0 && data.docs.map((doc) => new Document(doc, this));
    documents.sort((a, b) => a.sort - b.sort);
    this.documents = documents;
}
